import script from "./IconPower1.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconPower1.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__